import React, { useState, useEffect, useCallback } from 'react';

import styles from './styles.module.scss';

import BasicDetails from './Steps/BasicDetails';
import SiteDetails from './Steps/SiteDetails';
import Configuration from './Steps/Configuration';
import CredentialDetails from './Steps/CredentialDetails';
import DoorSettings from './Steps/DoorSettings';
import ChannelConfiguration from './Steps/ChannelConfiguration';
import { IconButton, useMediaQuery } from '@material-ui/core';
import { doCreateOrganisationAccessPoint, doCreateOrganisationController, doReadOrganisationSites } from '../../../../../../redux/thunks/organisation';
import { useDispatch } from 'react-redux';
import Button from '../../../../../../components/Buttons/Button';
import { credsTypesMap } from '../../../../../../utils/Common';
import { CloseRounded } from '@material-ui/icons';
import AddDoors from './Steps/AddDoors/AddDoors';
import DownstreamBoard from './Steps/DownstreamBoard/DownstreamBoard';
import Typography from '../../../../../../components/Typography/Typography';
import { colors } from '../../../../../../styles/colors';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import SButton from '../../../../../../components/SButton/SButton';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import useIsMobile from '../../../../../../hooks/useIsMobile';

const defaultTabs = [
  { title: 'Basic Details' },
  { title: 'Site Details' },
  { title: 'Configuration' },
  { title: 'Credential Settings' },
  { title: 'Settings' },
]

const azureZktecoTabs = [
  { title: 'Basic Details' },
  { title: 'Site Details' },
  { title: 'Configuration' },
  { title: 'Configuration' },
  { title: 'Credential Settings' },
  { title: 'Settings' },
]

const controllerTabs = [
  { title: 'Basic Details' },
  { title: 'Site Details' },
]

const azureControllerTabs = [
  { title: 'Basic Details' },
  { title: 'Site Details' },
  { title: 'Downstream Board' },
]

const AddAccessPointModal = ({
  showAccessPointPopup,
  togglePopup,
  customerId,
  partnerId
}) => {



  const popupToggle = useCallback(() => {
    togglePopup('AddAccessPoint');
  }, [togglePopup]);

  const dispatch = useDispatch();

  const isSmallScreen = useMediaQuery('(max-width:768px)');
  const width60 = useIsMobile(1342)

  const [accessPointDetails, setAccessPointDetails] = useState({});
  const [tabs, setTabs] = useState([])
  const [activeStep, setActiveStep] = useState(0);
  const [success, setSuccess] = useState({ show: false, accessPoints: [] })
  const [controllerConfirmation, setControllerConfirmation] = useState(false);
  const [addDoors, setAddDoors] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  useEffect(() => {
    setTabs(defaultTabs)
  }, [])

  useEffect(() => {
    configureTabs(accessPointDetails?.withController, accessPointDetails?.controllerType, accessPointDetails?.configuration?.value);
  }, [accessPointDetails?.withController, accessPointDetails?.controllerType, accessPointDetails?.configuration?.value])

  const configureTabs = (withController, controllerType) => {
    const isAzure_zkteco = withController && ['2', '3'].includes(controllerType);
    const isAzure = withController && controllerType === '2';
    const isIstar = withController && controllerType === '5';
    const isOthers = withController && controllerType === '4';

    let filteredTabs = [...defaultTabs]
    if (isAzure_zkteco) {
      filteredTabs = azureZktecoTabs;
    }

    if (withController && (!isOthers || isIstar)) {
      filteredTabs = controllerTabs;
    }

    if (isAzure) {
      filteredTabs = azureControllerTabs;
    }

    if (withController && controllerType === "4") {
      filteredTabs = filteredTabs?.filter(tab => tab?.title !== 'Settings')
    }

    setTabs(filteredTabs)
  }

  const hUpdatedBasicDetails = (withController, controllerType) => {
    configureTabs(withController, controllerType)
  }

  const handleNext = useCallback((data, nextStep, resetData) => {
    if (resetData) {
      setAccessPointDetails({ ...data })
      setActiveStep(nextStep)
    } else {
      const tempAccessPointDetails = { ...accessPointDetails, ...data }
      if ((accessPointDetails?.configuration?.value &&
        data?.configuration?.value &&
        data?.configuration?.value !== accessPointDetails?.configuration?.value) ||
        (accessPointDetails?.prevEntrySerialNum &&
          data?.entryDeviceSerialNum?.value &&
          accessPointDetails?.prevEntrySerialNum !== data?.entryDeviceSerialNum?.value
        )
      ) {

        delete tempAccessPointDetails?.comProtocal
        delete tempAccessPointDetails?.checkedCredTypes
        delete tempAccessPointDetails?.commonCredentials
        delete tempAccessPointDetails?.checkedCommonCred
        delete tempAccessPointDetails?.supportedAccessType
        delete tempAccessPointDetails?.credTypes
        delete tempAccessPointDetails?.prevEntrySerialNum

        delete tempAccessPointDetails?.lockingMech
        delete tempAccessPointDetails?.relayTime
        delete tempAccessPointDetails?.inveteredRelayLogic
        delete tempAccessPointDetails?.attendanceEnabled
      }
      setAccessPointDetails(tempAccessPointDetails)

      if (accessPointDetails?.withController && accessPointDetails?.controllerType !== '4' && !['2', '5']?.includes(accessPointDetails?.controllerType) && (nextStep - 1) === 1) {
        processController(tempAccessPointDetails);
        // setControllerConfirmation(true);
      } else {
        setActiveStep(nextStep)
      }
    }

  }, [accessPointDetails])

  const handleBack = useCallback((step) => {
    setActiveStep(step)
  }, [])

  function bitMapCreds(data) {
    const keys = Object?.keys(credsTypesMap);

    const bitMap = [];

    keys.forEach((key, index) => {
      if (data[key]) {
        if (key === "mobile_ble") {
          bitMap.push(1, 1, 1);
        } else {
          bitMap.push(1);
        }
      } else {
        if (key === "mobile_ble") {
          bitMap.push(0, 0, 0);
        } else {
          bitMap.push(0);
        }
      }
    });

    return parseInt(bitMap?.reverse()?.join(''), 2);
  }

  const generateAccessPointsPayload = useCallback((accessPointData) => {
    const apData = {
      name: accessPointData?.accessPointName,
      configuration: accessPointData?.configuration?.value,
      enableAttendance: !!accessPointData?.attendanceEnabled,
      isControllerAttached: accessPointData?.withController,
      controllerType: accessPointData?.withController ? Number(accessPointData?.controllerType) : 0,
      doorSensorSettings: {
        doorSensorEnable: !!accessPointData?.doorSensorEnabled,
        doorSensorType: accessPointData?.normallyOpen ? 1 : 2,
      }
    }
    let hasChannel = false;
    if (['2', '3', '5']?.includes(accessPointData?.controllerType) && accessPointData?.channelNo) {
      apData["channelNo"] = accessPointData?.channelNo;
      hasChannel = true;
    }
    apData["wireProtocol"] = hasChannel ? Number(accessPointData?.wireProtocol) :
      accessPointData?.wireProtocolNotSupported ? 1 : Number(accessPointData?.comProtocal || '1')
    const devices = []
    const axuData = {};
    if (accessPointData?.withController && accessPointData?.controllerType === "1" && accessPointData?.auxInput) {
      axuData["auxInputEnable"] = accessPointData?.auxInput?.enabled;
      axuData["auxInputType"] = accessPointData?.auxInput?.enabled ? Number(accessPointData?.auxInput?.inputType) : 0;
    }
    if (accessPointData?.configuration?.formOptions?.entry) {
      devices.push({
        serialNumber: accessPointData?.entryDeviceSerialNum?.value,
        deviceType: 1,
        ...axuData
      })
    }
    if (accessPointData?.configuration?.formOptions?.exit) {
      devices.push({
        serialNumber: accessPointData?.exitDeviceSerialNum?.value,
        deviceType: 2,
        ...axuData
      })
    }

    if (accessPointData?.configuration?.formOptions?.control) {
      devices.push({
        serialNumber: hasChannel ? accessPointData?.controllerDeviceSerialNum?.vendorToSpintlySerialNum : accessPointData?.controllerDeviceSerialNum?.value,
        deviceType: hasChannel ? 4 : 3,
        ...axuData
      })
    }
    apData['devices'] = devices;

    if (accessPointData?.lockingMech?.value) {
      apData['lockingMechanism'] = accessPointData?.lockingMech?.value;
    }

    if (accessPointData?.relayTime) {
      apData['relaySettings'] = {
        relayOnTime: Number(accessPointData?.relayTime),
        invertRelayLogic: accessPointData?.inveteredRelayLogic
      };
    }

    if (accessPointData?.configuration?.value !== 4) {
      apData["credentials"] = {
        supportedAccessType: accessPointData?.supportedAccessType,
        enabledAccessType: bitMapCreds(accessPointData?.checkedCredTypes)
      }
      if (accessPointData?.controllerType === "4" && accessPointData?.checkedCommonCred?.count > 0) {
        apData["credentials"]["commonCredentials"] = bitMapCreds(accessPointData?.checkedCommonCred);
        apData["credentials"]["commonCredentialBitSize"] = Number(accessPointData?.commonCredentialFormat?.slice(0, 2));
        apData["credentials"]["changeForAllAccessPoints"] = accessPointData?.changeForAllAccessPoints === false ? false : true;
        if (accessPointData?.commonCredentialType === "1") {
          apData["credentials"]["commonCredentialsValue"] = Number(accessPointData?.commonCredentials);
        } else {
          apData["credentials"]["cardNumber"] = Number(accessPointData?.cardNumber);
          apData["credentials"]["facilityCode"] = Number(accessPointData?.facilityCode);
        }
      }
    }

    if (accessPointData?.configuration?.value === 9) {
      apData["channelExtenderSettings"] = {
        channelDetails: Object?.entries(accessPointData?.configuration?.channelExtenderSettings?.channelMapping)?.map(([key, details]) => {
          const id = parseInt(key.replace("CH", ""), 10);
          return {
            channelId: id,
            applicationName: details.floor.value
          };
        }),
        application: accessPointData?.configuration?.channelExtenderSettings?.application === "Elevator" ? 1 : 2,
        numberOfBoards: accessPointData?.configuration?.channelExtenderSettings?.numberOfBoards,
      }
    }
    return apData;
  }, [])

  const handleSave = useCallback((data) => {
    setInProgress(true)
    setAccessPointDetails(prev => ({
      ...prev, ...data
    }));
    const tempAPDetails = {
      ...accessPointDetails,
      ...data,
    }

    const postData = [];
    const accessPointNames = [];
    if (['2', '3']?.includes(tempAPDetails?.controllerType)) {
      const channelDetailsKeys = Object?.keys(tempAPDetails?.channelDetails);
      for (let i = 0; i < channelDetailsKeys?.length; i++) {
        const channelData = tempAPDetails?.channelDetails[channelDetailsKeys[i]];
        if (channelData?.checked) {
          const formattedChannelData = {
            ...tempAPDetails,
            ...channelData,
            channelNo: i + 1,
          }
          postData.push(generateAccessPointsPayload(formattedChannelData));
          accessPointNames?.push(formattedChannelData?.accessPointName)
        }
      }
    } else {
      postData.push(generateAccessPointsPayload(tempAPDetails));
      accessPointNames?.push(tempAPDetails?.accessPointName)
    }
    setSuccess({ show: false, accessPoints: accessPointNames });

    dispatch(doCreateOrganisationAccessPoint({
      partnerId,
      networkId: tempAPDetails?.network?.id,
      organisationId: customerId,
      payload: postData,
      callback: () => {
        if (postData[0]?.credentials?.changeForAllAccessPoints) {
          dispatch(
            doReadOrganisationSites({
              partnerId: partnerId,
              organisationId: customerId,
              displayNotification: false,
            }),
          );
        }
        setSuccess(prev => ({ ...prev, show: true }))
      },
      onFinally: () => {
        setInProgress(false)
      }
    }))
  }, [accessPointDetails, customerId, dispatch, generateAccessPointsPayload, partnerId])

  const renderStepper = (steps = [], currentStep = 0) => {
    return (<>
      <div className={styles['page-flag-container']}>
        {steps?.map((step, index) => {
          return (
            <>
              <div className={index <= currentStep ? styles['page-flag'] : styles['page-flag-next']}>{index + 1}</div>
              {
                (index + 1) !== steps?.length &&
                <div className={styles['page-flag-separator-next']}></div>
              }
            </>
          )
        })}
      </div>
      {steps[currentStep]?.title &&
        <div className={styles['form-name-container']}>
          <h2 className={styles['form-name']}>{steps[currentStep]?.title}</h2>
        </div>
      }
    </>)
  }

  const handleControllerSave = (data) => {
    setAccessPointDetails(prev => ({
      ...prev, ...data
    }));
    const tempAccessPointDetails = { ...accessPointDetails, ...data }
    processController(tempAccessPointDetails);
  }

  const renderSteps = useCallback(() => {
    const isAzure_zkteco = accessPointDetails?.withController && ['2', '3', '5'].includes(accessPointDetails?.controllerType);
    const isAzure = accessPointDetails?.withController && accessPointDetails?.controllerType === '2';
    const isIstar = accessPointDetails?.withController && accessPointDetails?.controllerType === '5';
    switch (activeStep) {
      case 0:
        return <BasicDetails hClose={popupToggle} hNext={handleNext} accessPointDetails={accessPointDetails} updatedBasicDetails={hUpdatedBasicDetails} />
      case 1:
        return <SiteDetails hNext={handleNext} hBack={handleBack} hSave={handleControllerSave} accessPointDetails={accessPointDetails} inProgress={inProgress} />
      case 2:
        return (isAzure) ?
          <DownstreamBoard accessPointDetails={accessPointDetails} hNext={handleControllerSave} hBack={handleBack} inProgress={inProgress} /> :
          <Configuration hNext={handleNext} hBack={handleBack} accessPointDetails={accessPointDetails} inProgress={inProgress} />
      case 3:
        return isAzure_zkteco ?
          <ChannelConfiguration hNext={handleNext} hBack={handleBack} accessPointDetails={accessPointDetails} inProgress={inProgress} /> :
          accessPointDetails?.configuration?.value === 4 ? <DoorSettings hClose={popupToggle} hNext={handleNext} hBack={handleBack} hSave={handleSave} accessPointDetails={accessPointDetails} backStep={2} inProgress={inProgress} /> :
            <CredentialDetails hNext={handleNext} hBack={handleBack} hSave={handleSave} accessPointDetails={accessPointDetails} setAccessPointDetails={setAccessPointDetails} nextStep={4} apiInProgress={inProgress} />
      case 4:
        return isAzure_zkteco ?
          <CredentialDetails hNext={handleNext} hBack={handleBack} accessPointDetails={accessPointDetails} setAccessPointDetails={setAccessPointDetails} nextStep={5} apiInProgress={inProgress} /> :
          <DoorSettings hClose={popupToggle} hNext={handleNext} hBack={handleBack} hSave={handleSave} accessPointDetails={accessPointDetails} backStep={3} inProgress={inProgress} />
      case 5:
        return <DoorSettings hClose={popupToggle} hNext={handleNext} hBack={handleBack} hSave={handleSave} accessPointDetails={accessPointDetails} backStep={4} inProgress={inProgress} />

      default:
        break;
    }
  }, [activeStep, accessPointDetails, popupToggle, handleNext, handleBack, handleSave, inProgress])

  const processController = (apDetails) => {
    setInProgress(true);
    const ap = apDetails || accessPointDetails;
    const payload = {
      serialNumber: (ap?.withController && ['2']?.includes(ap?.controllerType)) ? ap?.controllerDeviceSerialNum?.vendorToSpintlySerialNum : ap?.controllerDeviceSerialNum?.value,
      application: 1,
      isController: true,
      wireProtocol: Number(ap?.wireProtocol),
      noOfPortsSupported: ap?.noOfControllerChannels,
      controllerType: (Number(ap?.controllerType) === 1 && ap?.controllerDeviceSerialNum?.value?.slice(0, 4) === '1044') ? 6 : Number(ap?.controllerType),
      downstreamBoards: ap?.boards?.map(b => ({
        comPort: Number(b?.port),
        noOfPortsSupported: Number(b?.channels)
      }))
    }

    dispatch(doCreateOrganisationController({
      partnerId,
      networkId: ap?.network?.id,
      organisationId: customerId,
      payload: payload,
      callback: () => {
        setAccessPointDetails(prev => ({
          ...prev,
          controllerType: (Number(ap?.controllerType) === 1 && ap?.controllerDeviceSerialNum?.value?.slice(0, 4) === '1044') ? "6" : String(ap?.controllerType)
        }))
        setControllerConfirmation(true);
      },
      onFinally: () => {
        setInProgress(false)
      }
    }))
    // setControllerConfirmation(true);

  }

  const hAddDoorsSucces = (addedDoors = []) => {
    setSuccess({ show: true, accessPoints: addedDoors });
    setAddDoors(false)
  }


  return (
    <>

      <SDialog
        title='Add Access Point'
        open={showAccessPointPopup && !success?.show && !controllerConfirmation && !addDoors}
        onClose={popupToggle}
        isFormDialog={true}
        width='40rem'
      // secondaryButtonConfig={{
      //   text: 'Cancel',
      //   onClick: popupToggle
      // }}
      // primaryButtonConfig={{
      //   text: 'Delete',
      //   color: 'error',
      //   onClick: handleDeleteAccessPoint
      // }}
      >
        <FlexColumn alignItems='start'>
          {renderStepper(tabs, activeStep)}
          {renderSteps()}
        </FlexColumn>
      </SDialog>

      <SDialog
        title='Add Doors'
        open={addDoors}
        onClose={popupToggle}
        isFormDialog={true}
      >
        <AddDoors accessPoint={accessPointDetails} partnerId={partnerId} customerId={customerId} onSuccess={hAddDoorsSucces} />
      </SDialog>

      <SDialog
        title='Controller Added'
        open={controllerConfirmation}
        onClose={popupToggle}
        width={width60 ? '60%' : '40%'}
        secondaryButtonConfig={{
          text: 'Finish - Add controller only',
          color: 'grey',
          onClick: popupToggle
        }}
        primaryButtonConfig={{
          text: 'Continue setup',
          onClick: () => { setAddDoors(true); setControllerConfirmation(false) }
        }}
        actionsContainer={{
          wrap: isSmallScreen ? 'wrap' : 'nowrap'
        }}
      >
        <Typography style={{ marginTop: '1rem' }} variant={"b1SB"} color={colors.grey700}>The controller has been successfully added. You can finish now and add doors later, <span style={{ display: 'block' }}>or continue to setup doors on the controller.</span> </Typography>
      </SDialog>

      <SDialog
        title='Access Points Created'
        open={success?.show}
        onClose={() => {
          popupToggle()
          setSuccess(prev => ({ ...prev, show: false }));
        }}
        primaryButtonConfig={{
          text: 'Done',
          onClick: () => {
            popupToggle()
            setSuccess(prev => ({ ...prev, show: false }));
          },
          fullWidth: false
        }}
        actionsContainer={{
          justifyContent: 'end'
        }}
      >
        <Typography style={{ marginTop: '1rem' }} variant={"b1M"}>{
          `Successfully added access points ${success?.accessPoints.length > 2
            ? `${success?.accessPoints.slice(0, -1).map(item => `"${item}"`).join(", ")} and "${success?.accessPoints[success?.accessPoints.length - 1]}"`
            : success?.accessPoints.map(item => `"${item}"`).join(" and ")
          }`
        }</Typography>
      </SDialog>
    </>
  );
};

export default AddAccessPointModal;
